import React from 'react';
import { useTranslation } from 'react-i18next';
import MessageModal from '@wix/da-ds/pkg/modals/dsPresets/MessageModal';
import { Warning } from '@wix/da-ds/pkg/Icons/Confirmations/Warning';
import { CancelButton } from '@wix/da-ds/pkg/modals/dsPresets/MessageModal/buttons';
import BuyCoreBrandedButton from '@wix/da-shared-react/pkg/Button/core/dsPresets/BuyCoreBrandedButton';
import { BiData, BuyCoreButtonBiEvent } from '@wix/da-bi/pkg/events';
import { ReferralType } from '@wix/da-bi/pkg/constants';

import s from './UpsellToAddUsersModal.scss';

export interface Props {
  requestClose: () => void;
}

const UpsellToAddUsersModal: React.FC<Props> = ({ requestClose }) => {
  const { t } = useTranslation('damz');

  return (
    <MessageModal
      className={s['root']}
      isOpen
      variant="horizontal"
      image={<Warning />}
      onRequestClose={requestClose}
      title={t('damz.modal.upsellToAddUsersModal.title')}
      message={t('damz.modal.upsellToAddUsersModal.message')}
      footerButtons={[
        <CancelButton key="cancel" onClick={requestClose}>
          {t('damz.modal.upsellToAddUsersModal.cancel')}
        </CancelButton>,
        <BuyCoreBrandedButton
          key="confirm"
          size="large"
          withMobileDefaultLabel={false}
          rel="noopener"
          referer={
            typeof window !== 'undefined' ? window.location.href : undefined
          }
          biData={BiData<BuyCoreButtonBiEvent>({
            evid: 375,
            referral_info: ReferralType.MESSAGES_ADD_TO_CHANNEL,
          })}
        >
          {t('damz.modal.upsellToAddUsersModal.confirm')}
        </BuyCoreBrandedButton>,
      ]}
    />
  );
};

export default UpsellToAddUsersModal;
